import { call, put } from "redux-saga/effects";
import {
  fetchInventoryFinalUpdateSummarySuccess,
  importFileFailed,
  importFileSuccess,
} from "./actions";
import { showErrorNotification } from "src/util/notifications";
import api from "src/util/api";
import {
  INVENTORY_FINAL_UPDATE_URL,
} from "src/util/constants/api.constants";

export function* fetchInventoryFinalUpdateSummary(): Generator {
  try {
    let url = INVENTORY_FINAL_UPDATE_URL.INVENTORY_FINAL_UPDATE_SUMMARY_LIST;
    const data: any = yield call(api.get, url);
    yield put(fetchInventoryFinalUpdateSummarySuccess(data));
  } catch (e: any) {
    showErrorNotification(null, e);
  }
}

export function* importInventoryFinalUpdateFile({ payload, actionType }: any): Generator {
  try {
    let url = INVENTORY_FINAL_UPDATE_URL.INVENTORY_FINAL_UPDATE_IMPORT;
    const formdata = new FormData();
    formdata.append("file", payload.file);
    formdata.append("UploadedBy", payload.UserName);
    const data: any = yield call(api.post, url, formdata);
    yield put(importFileSuccess(data));
  } catch (e: any) {
    yield put(importFileFailed(e.response.data));
  }
}

export function fetchInventoryFinalUpdateDetails(payload: any) {
  let url = INVENTORY_FINAL_UPDATE_URL.INVENTORY_FINAL_UPDATE_DETAILS + payload;
  return api.get(url);
}

export function fetchInventoryFinalUpdateValidations(payload: any) {
  let url = INVENTORY_FINAL_UPDATE_URL.INVENTORY_FINAL_UPDATE_VALIDATIONS + payload;
  return api.get(url);
}

export function runInventoryFinalUpdateValidation(payload: any) {
  let url = INVENTORY_FINAL_UPDATE_URL.INVENTORY_FINAL_UPDATE_VALIDATION;
  return api.post(url, payload);
}

export function finalUpdate(payload: any) {
  let url = INVENTORY_FINAL_UPDATE_URL.INVENTORY_FINAL_UPDATE;
  return api.post(url, payload);
}